var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.5 17.9086V12.2026C7.5 11.6774 7.94772 11.2516 8.5 11.2516H11.5C12.0523 11.2516 12.5 11.6774 12.5 12.2026V17.9086M9.42048 3.08455L2.92048 7.48026C2.65668 7.65866 2.5 7.94745 2.5 8.25528V16.4821C2.5 17.2699 3.17157 17.9086 4 17.9086H16C16.8284 17.9086 17.5 17.2699 17.5 16.4821V8.25528C17.5 7.94745 17.3433 7.65866 17.0795 7.48026L10.5795 3.08455C10.2326 2.84991 9.76744 2.84991 9.42048 3.08455Z",
    stroke: "#7F7D83",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome04);
export default __webpack_public_path__ + "static/media/home-04.3a5cbf33b6ed6a195bc6d44838f98686.svg";
export { ForwardRef as ReactComponent };